import {
  SET_ACTIVE_CLIENT
} from '../actions';

const initialState = {
};
export default function (state = initialState, action) {

  switch(action.type) {
    case SET_ACTIVE_CLIENT:
      return action.payload;

    default:
      return state;
  }
}